// Single source of truth for the look. Matches the approved prototype.
const theme = {
  colors: {
    cream: "#FBF7EF",
    creamDeep: "#F3EBDC",
    surface: "#FFFDF8",
    ink: "#2A2A26",
    inkSoft: "#6B6960",
    green: "#2F4A3C",
    greenDeep: "#223828",
    rose: "#D98C82",
    roseSoft: "#F0CFC9",
    gold: "#C9B68E",
    hair: "#E4DAC6",
  },
  radius: "18px",
  shadow: "0 1px 2px rgba(42,42,38,.04), 0 12px 30px -12px rgba(42,42,38,.12)",
  font: {
    display: "'Fraunces', serif",
    body: "'DM Sans', system-ui, sans-serif",
  },
  maxWidth: "1200px",
};

export default theme;
